import { RequestTypes } from "@/types/AdvantageCardRequest";
import ButtonComponent from "@/components/ButtonComponent/ButtonComponent";
import styles from "./GetTheApp.module.scss";

const TextButton = (
  <ButtonComponent
    buttonText={"TEXT"}
    requestType={RequestTypes.text}
    iconName={"message-dots"}
    color={"white"}
    className={"caprx-icon-messages-bubble"}
    testId="request-card-text-button"
  />
);
const EmailButton = (
  <ButtonComponent
    buttonText={"EMAIL"}
    requestType={RequestTypes.email}
    iconName={"envelope-closed"}
    color={"white"}
    className={"caprx-icon-mail-letter"}
    testId="request-card-email-button"
  />
);
const PrintButton = (
  <ButtonComponent
    buttonText={"PRINT"}
    requestType={RequestTypes.print}
    iconName={"printer"}
    color={"white"}
    className={"caprx-icon-print"}
    testId="request-card-print-button"
  />
);

const GetTheApp: React.FC = () => {
  // const isMobile = useFindUserDeviceType();

  return (
    <>
      {/* <Paragraph className={styles.FirstText}>
        The best way to use your discount card is to download the free <span className={styles.BoldText}>CRx Advantage Savings</span> app:
      </Paragraph>
      <div className={styles.CtaContainer}>
        {!isMobile ? <Image className={styles.Qrcode} src={discountQRCode} alt="App QR Code" /> : ""}
        <DownloadAppLogo />
      </div>
  <hr className={styles.HorizontalRule} /> */}
      <div data-testid="get-the-app-container">
        <div className={styles.SecondText} data-testid="get-the-app-container-text">
          Download your free virtual card to unlock discounts:
        </div>
        <div className={styles.ButtonAlignment}>
          {TextButton}
          {EmailButton}
          {PrintButton}
        </div>
      </div>
    </>
  );
};

export default GetTheApp;
